module.exports = __webpack_public_path__ + "static/media/Health&Safety.266d1d14.jpg";